module.exports = __webpack_public_path__ + "img/NFK.b488c0cb.svg";